/* eslint-disable */
const getters = {
  getPostCategories(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
